export default __webpack_public_path__ + "static/media/Pic1 - SRITISHNA SARANGI-min.6022b74e.jpg";